import React, { useState } from 'react';
import { Glasses, ChevronLeft, ChevronRight, X } from 'lucide-react';
import { useStore } from '../store';

export default function LookbookComponent() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const isModelAnimationComplete = useStore((state) => state.isModelAnimationComplete);

  const lookbookPages = [
    {
      image: '/images/lookbook/2025/spring/test03.jpg',
      caption: '2025 Spring Lookbook',
      description: 'Sophisticated options for special occasions'
    },
    {
      image: '/images/lookbook/2025/spring/test04.jpg',
      caption: '2025 Spring Lookbook',
      description: 'Sophisticated options for special occasions'
    }
  ];

  const handleImageError = (e) => {
    console.error(`Failed to load image: ${e.target.src}`);
    e.target.src = '/images/fallback.png';
  };

  const handleNext = () => {
    setCurrentPage((prev) => (prev + 1) % lookbookPages.length);
  };

  const handlePrevious = () => {
    setCurrentPage((prev) => (prev - 1 + lookbookPages.length) % lookbookPages.length);
  };

  return (
    <div>
      {/* Lookbook Button */}
      {isModelAnimationComplete && (
        <div className="fixed z-50 lg:bottom-24 bottom-24 left-1/2 transform -translate-x-1/2 opacity-0 animate-fade-in">
          <button
            onClick={() => setIsDialogOpen(true)}
            className="relative group bg-stone-800 text-white px-8 py-2.5 rounded-lg 
              hover:bg-stone-600 transition-all duration-300 min-w-[250px]
              flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
          >
            <Glasses className="w-5 h-5" />
            2025 Spring Looks
          </button>
        </div>
      )}

      {/* Lookbook Modal */}
      {isDialogOpen && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[100] 
            flex items-center justify-center p-4"
          onClick={() => setIsDialogOpen(false)}
        >
          <div
            className="bg-white rounded-xl w-full max-w-4xl h-[80vh] flex flex-col
              shadow-2xl relative overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={() => setIsDialogOpen(false)}
              className="absolute top-4 right-4 z-50 text-gray-500 hover:text-gray-800
                bg-white/80 rounded-full p-1"
            >
              <X className="w-6 h-6" />
            </button>

            {/* Content Area */}
            <div className="flex-1 overflow-hidden relative">
              {/* Main Image with Error Handling */}
              <div className="h-full w-full relative">
                <img
                  src={lookbookPages[currentPage].image}
                  alt={lookbookPages[currentPage].caption}
                  className="w-full h-full object-cover"
                  onError={handleImageError}
                />
                
                {/* Caption Overlay */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-8 text-white">
                  <h3 className="text-2xl font-semibold mb-2">
                    {lookbookPages[currentPage].caption}
                  </h3>
                  <p className="text-white/80">
                    {lookbookPages[currentPage].description}
                  </p>
                </div>
              </div>

              {/* Navigation Arrows */}
              <button
                onClick={handlePrevious}
                className="absolute left-4 top-1/2 -translate-y-1/2 
                  bg-white/80 hover:bg-white text-gray-800 p-2 rounded-full
                  transition-all duration-300 shadow-lg"
              >
                <ChevronLeft className="w-6 h-6" />
              </button>
              <button
                onClick={handleNext}
                className="absolute right-4 top-1/2 -translate-y-1/2 
                  bg-white/80 hover:bg-white text-gray-800 p-2 rounded-full
                  transition-all duration-300 shadow-lg"
              >
                <ChevronRight className="w-6 h-6" />
              </button>

              {/* Page Indicators */}
              <div className="absolute bottom-28 left-1/2 transform -translate-x-1/2 
                flex gap-2 z-10">
                {lookbookPages.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentPage(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 
                      ${currentPage === index ? 'bg-white w-4' : 'bg-white/50'}`}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}